export const camelCasetoCapitalizedSpacedWords = (string: string) => {
  return string
    .split("_")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ")
}
